/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Price_FcInputs */

const en_fc_cmp_price_fc = /** @type {(inputs: Fc_Cmp_Price_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free forever`)
};

/**
* | output |
* | --- |
* | "Free forever" |
*
* @param {Fc_Cmp_Price_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_price_fc = /** @type {((inputs?: Fc_Cmp_Price_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Price_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_price_fc(inputs)
});
export { fc_cmp_price_fc as "fc.cmp.price.fc" }